import { ProductMultiplierProductType, ProductMultiplierTypeAttributes } from '@/types'
import { CreateProductMultiplierTypeMutation } from './__generated__/create_mutation'
import { Mutation as CreateMutation } from './create_mutation'
import { useForm } from '@/helpers/useForm'
import { useEffect } from 'react'
import { Query as TableQuery } from './table_query'

interface Props {
  onSuccess: () => void
  defaultValues: Partial<ProductMultiplierTypeAttributes>
}

export const Form = ({ onSuccess, defaultValues }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    mutationLoading
  } = useForm<CreateProductMultiplierTypeMutation, ProductMultiplierTypeAttributes, never, never>({
    defaultValues: {
      multiplierTypeId: '',
      productId: '',
      productType: ProductMultiplierProductType.AssetType,
      ...defaultValues
    },
    mutation: CreateMutation,
    resultKey: 'createProductMultiplierType',
    refetchQueries: [TableQuery]
  })

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  return (
    <div className="flex flex-col gap-6">
      { formBuilder.buildQueryError() }
      { formBuilder.buildField({ name: 'Multiplier', field: 'multiplierTypeId', type: 'product-multiplier-type' }) }
      { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
    </div>
  )
}
